import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='10 DLC Settings'
      breadcrumbs={[
        {
          label: 'History',
        },
        {
          label: '10 DLC Settings',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/settings/10-dlc',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
});
